import { render, staticRenderFns } from "./Rijnkanaal.vue?vue&type=template&id=dc918458&"
import script from "./Rijnkanaal.vue?vue&type=script&lang=ts&"
export * from "./Rijnkanaal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports